/**
 * Reading layout (ui.js behaviour 1.5-3): `tik.readMode` is `"split"` (default) or `"full"`.
 * Full mode adds `html.tik-read-full`, which hides the list pane of `.content.split` on ≥901 px.
 * The two top-bar buttons (`.tik-modebtn`, `.tik-backbtn`) carry the ui.js labels, which are not
 * part of the i18n dictionaries.
 */
import type { Lang } from '$lib/i18n';

export type ReadMode = 'full' | 'split';
export const READ_MODE_KEY = 'tik.readMode';

export function readReadMode(): ReadMode {
  try {
    return localStorage.getItem(READ_MODE_KEY) === 'full' ? 'full' : 'split';
  } catch {
    return 'split';
  }
}

/** Persist and apply `html.tik-read-full`. */
export function applyReadMode(mode: ReadMode): void {
  try {
    localStorage.setItem(READ_MODE_KEY, mode);
  } catch {
    /* private mode */
  }
  if (typeof document !== 'undefined') document.documentElement.classList.toggle('tik-read-full', mode === 'full');
}

export interface ReadModeLabels {
  /** Label of the mode button while split is active (click → full page). */
  toFull: string;
  /** Label of the mode button while full page is active (click → split). */
  toSplit: string;
  back: string;
}

const LABELS: Record<Lang, ReadModeLabels> = {
  ar: { toSplit: 'عرض مقسوم: القائمة والرسالة معًا', toFull: 'فتح الرسائل في صفحة كاملة', back: 'رجوع إلى القائمة' },
  en: { toSplit: 'Split view', toFull: 'Full page view', back: 'Back to list' },
};

export function readModeLabels(lang: Lang): ReadModeLabels {
  return LABELS[lang] ?? LABELS.ar;
}
